import React, { useEffect, useState } from "react";
import MainHeader from "../../../../layouts/pageLayout/MainHeader";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import PayoutSplit from "./PayoutSplit";
import AffiliatePayout from "./AffiliatePayout";
import Tabination from "../../../../reusableComponents/Tabination";
import WithdrawalHistory from "./WithdrawalHistory";
import Select from "react-select";
import { newCustomStyles, cryptoNewCustomStyles } from "../../../../customstyle/customstyle";
import { useSelector } from "react-redux";

const PayoutIndex = () => {
  const location = useLocation();
  const selectedBrand = useSelector((state) => state.brand.selectedBrand);

  const path = location.pathname.split("/")[2];
  const [activeTab, setActiveTab] = useState(0);

  // Status filter options
  const statusOption = [
    {
      label: "All",
      value: null,
    },
    {
      label: "Approved",
      value: "approved",
    },
    {
      label: "New",
      value: "new",
    },
    {
      label: "Rejected",
      value: "rejected",
    },
  ];

  const [selectedStatus, setSelectedStatus] = useState(statusOption[0]);

  const handleStatusChange = (selectedOption) => {
    setSelectedStatus(selectedOption);
  };

  const items = [
    {
      name: "Trading Account",
      path: "payout-split",
    },
    {
      name: "Affiliate",
      path: "affiliate-payout",
    },
    {
      name: "Withdrawal History",
      path: "withdrawal-history",
    },
  ];
  useEffect(() => {
    switch (path) {
      case "payout-split":
        setActiveTab(0);
        break;
      case "affiliate-payout":
        setActiveTab(1);
        break;
      case "withdrawal-history":
        setActiveTab(2);
        break;
      default:
        break;
    }
  }, [path]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="withdrawalPageContainer">
      <div className="pageNavigator">
        <Tabination
          variant={7}
          tabItems={items}
          activeTab={activeTab}
          breakpoint={480}
        />
        {activeTab === 2 && (
          <div className="wrapperDashboard">
            <div className="dashboard_nav">
              <Select
                value={selectedStatus}
                options={statusOption}
                onChange={handleStatusChange}
                placeholder="Select Status"
                styles={selectedBrand?.brand === "equity_edge" ? newCustomStyles(40) : selectedBrand?.brand === "crypto_edge" ? cryptoNewCustomStyles(40) : newCustomStyles(40)}
                className="tabination_var6"
                classNamePrefix="react-select"
                isSearchable={false}
              />
            </div>
          </div>
        )}
      </div>
      <Routes>
        <Route
          path="/"
          element={
            <Navigate
              to="payout-split"
              replace={true}
            />
          }
        />
        <Route
          path="payout-split"
          element={<PayoutSplit />}
        />
        <Route
          path="affiliate-payout"
          element={<AffiliatePayout />}
        />
        <Route
          path="withdrawal-history"
          element={<WithdrawalHistory selectedStatus={selectedStatus} />}
        />
        <Route
          path="*"
          element={
            <Navigate
              to="/"
              replace={true}
            />
          }
        />
      </Routes>
    </div>
  );
};

export default PayoutIndex;
